/**
 * Lightweight t() — no i18next / next-intl.
 * Dot keys: "nav.home" · placeholders: "{count}", "{price}", etc.
 */

export type MessageTree = { [key: string]: string | MessageTree };
export type Vars = Record<string, string | number | undefined | null>;

function lookup(tree: MessageTree, path: string): string | undefined {
  const parts = path.split(".");
  let cur: string | MessageTree | undefined = tree;
  for (const p of parts) {
    if (cur == null || typeof cur === "string") return undefined;
    cur = cur[p];
  }
  return typeof cur === "string" ? cur : undefined;
}

function interpolate(template: string, vars?: Vars): string {
  if (!vars) return template;
  return template.replace(/\{(\w+)\}/g, (_, name: string) => {
    const v = vars[name];
    if (v === undefined || v === null) return `{${name}}`;
    return String(v);
  });
}

/**
 * Resolve key from primary messages, then fallback, then return the key.
 */
export function translate(
  primary: MessageTree,
  fallback: MessageTree,
  key: string,
  vars?: Vars,
): string {
  const raw = lookup(primary, key) ?? lookup(fallback, key) ?? key;
  return interpolate(raw, vars);
}
